import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { CreateTankHistoryComponentForm, CreateTankHistoryPageHeader } from '@/components/pages/TankHistories/Create'
import { useTanks } from '@/pages/Tank/Tank.hooks'

import { useCreateTankHistory } from './Create.hooks'

const CreateTankHistory = () => {
  const { createTankHistory, loading } = useCreateTankHistory()

  const { id } = useParams()

  const { getTankDetail, getTankDetailResponse } = useTanks()

  useEffect(() => {
    if (id) {
      getTankDetail(Number(id))
    }
  }, [getTankDetail, id])

  return (
    <>
      <CreateTankHistoryPageHeader />
      <CreateTankHistoryComponentForm
        {...{ loading }}
        onSubmit={createTankHistory}
        netWeightMl={getTankDetailResponse?.detergents[0]?.netWeightMl || 0}
      />
    </>
  )
}

CreateTankHistory.displayName = 'CreateTankHistory'
export default CreateTankHistory
